/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Hide_DetailsInputs */



/**
* | output |
* | --- |
* | "Hide details" |
*
* @param {Error_Hide_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_hide_details = /** @type {((inputs?: Error_Hide_DetailsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Hide_DetailsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Details ausblenden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer les détails")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("隐藏详情")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("隱藏詳細資訊")
	if (locale === "ko") return /** @type {LocalizedString} */ ("상세 정보 숨기기")
	return /** @type {LocalizedString} */ ("Hide details")
});